import {Home} from './Componenets/Home'

export function Big(){

    return(
        <div>
            <Home/>
        </div>
    )
}